/**
 * 客户端运行时配置常量
 *
 * SilkReels 项目对接后:mycanvas 不持有任何上游 AI 服务的 API Key,
 * 所有 AI 调用统一走 backend(`/api/v1/ai/*`)。
 */
import { getConfiguredTenantCode } from '@/config/tenant-site'

/**
 * SilkReels backend 基地址。
 *
 * - 开发环境默认空串,由 vite.config.ts 的 `/api → http://localhost:8080` 代理完成转发
 * - 生产环境设置 `VITE_API_BASE` 指向网关域名
 * - 也允许设置为绝对地址(跨域时 backend 需开启 CORS + credentials)
 */
export const SILKREELS_API_BASE: string =
  import.meta.env.VITE_API_BASE ?? ''

/** 构建时绑定的租户 code(见 VITE_TENANT_CODE / 子域推导) */
export const SILKREELS_TENANT_CODE: string = getConfiguredTenantCode()

export { resolveTenantFromHost, TENANT_HEADER } from '@/config/tenant-site'

/** localStorage 持久化 key,api/auth 与 hooks/useAuth 共享 */
export const AUTH_STORAGE_KEY = 'silkreels:auth'
